import _slicedToArray from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, Children, useCallback, useMemo } from 'react';
import styles from './Combobox.scss.js';
import { ComboboxTextFieldContext, ComboboxListboxContext, ComboboxListboxOptionContext } from '../../utilities/combobox/context.js';
import { TextField } from './components/TextField/TextField.js';
import { Popover } from '../Popover/Popover.js';

function Combobox(_ref) {
  var children = _ref.children,
      activator = _ref.activator,
      allowMultiple = _ref.allowMultiple,
      onScrolledToBottom = _ref.onScrolledToBottom,
      _ref$preferredPositio = _ref.preferredPosition,
      preferredPosition = _ref$preferredPositio === void 0 ? 'below' : _ref$preferredPositio;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      popoverActive = _useState2[0],
      setPopoverActive = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      activeOptionId = _useState4[0],
      setActiveOptionId = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      textFieldLabelId = _useState6[0],
      setTextFieldLabelId = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      listboxId = _useState8[0],
      setListboxId = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      textFieldFocused = _useState10[0],
      setTextFieldFocused = _useState10[1];

  var shouldOpen = Boolean(!popoverActive && Children.count(children) > 0);
  var onOptionSelected = useCallback(function () {
    if (!allowMultiple) {
      setPopoverActive(false);
      setActiveOptionId(undefined);
    }
  }, [allowMultiple]);
  var handleClose = useCallback(function () {
    setPopoverActive(false);
    setActiveOptionId(undefined);
  }, []);
  var handleFocus = useCallback(function () {
    if (shouldOpen) {
      setPopoverActive(true);
    }
  }, [shouldOpen]);
  var handleChange = useCallback(function () {
    if (shouldOpen) {
      setPopoverActive(true);
    }
  }, [shouldOpen]);
  var handleBlur = useCallback(function () {
    if (popoverActive) {
      setPopoverActive(false);
      setActiveOptionId(undefined);
    }
  }, [popoverActive]);
  var textFieldContextValue = useMemo(function () {
    return {
      activeOptionId: activeOptionId,
      expanded: popoverActive,
      listboxId: listboxId,
      setTextFieldFocused: setTextFieldFocused,
      setTextFieldLabelId: setTextFieldLabelId,
      onTextFieldFocus: handleFocus,
      onTextFieldChange: handleChange,
      onTextFieldBlur: handleBlur
    };
  }, [activeOptionId, popoverActive, listboxId, setTextFieldFocused, setTextFieldLabelId, handleFocus, handleChange, handleBlur]);
  var listboxOptionContextValue = useMemo(function () {
    return {
      allowMultiple: allowMultiple
    };
  }, [allowMultiple]);
  var listboxContextValue = useMemo(function () {
    return {
      setActiveOptionId: setActiveOptionId,
      setListboxId: setListboxId,
      listboxId: listboxId,
      textFieldLabelId: textFieldLabelId,
      onOptionSelected: onOptionSelected,
      textFieldFocused: textFieldFocused,
      onKeyToBottom: onScrolledToBottom
    };
  }, [setActiveOptionId, setListboxId, listboxId, textFieldLabelId, onOptionSelected, textFieldFocused, onScrolledToBottom]);
  return (
    /*#__PURE__*/
    React.createElement(Popover, {
      active: popoverActive,
      onClose: handleClose,
      activator:
      /*#__PURE__*/
      React.createElement(ComboboxTextFieldContext.Provider, {
        value: textFieldContextValue
      }, activator),
      autofocusTarget: "none",
      preventFocusOnClose: true,
      fullWidth: true,
      preferInputActivator: false,
      preferredPosition: preferredPosition
    },
    /*#__PURE__*/
    React.createElement(Popover.Pane, {
      onScrolledToBottom: onScrolledToBottom
    }, Children.count(children) > 0 ?
    /*#__PURE__*/
    React.createElement(ComboboxListboxContext.Provider, {
      value: listboxContextValue
    },
    /*#__PURE__*/
    React.createElement(ComboboxListboxOptionContext.Provider, {
      value: listboxOptionContextValue
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: styles.Listbox
    }, children))) : null))
  );
}

Combobox.TextField = TextField;
export { Combobox };